import { useSelector } from "react-redux";

// ResizeObserver suppression is handled in public/index.html (must run before CRA bundle)
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import AppLocale from "./languages";
import Router from "./router/Router";
import { AuthProvider } from "./contexts/AuthContext";

export default function App() {
  const customise = useSelector((state) => state.customise);
  const currentAppLocale = AppLocale[customise.language];

  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={customise.direction}
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <AuthProvider>
          <Router />
        </AuthProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
